import { useState, useEffect, useRef } from "react";
import styles from "./index.module.scss";
import pillars from "../../assets/images/pillers.png";
import infiniprayerLogo from "../../assets/images/infini-prayer.png";
import { Button } from "../../common/components/Button";
import hdbImg from "../../assets/images/hdb-banner.png";
import infiniprayeraudio from "../../assets/images/Infiniprayer.mp3";
import {
  fetchProgramsData,
  formatDateWithDay,
  getRegistrationStatus,
  getStatusOfProgram,
} from "../../utils/registrationUtils";
import { getItemInLocalStorage } from "../../services/localStorage";
import { useNavigate } from "react-router-dom";
import Loader from "../../common/components/Loader";
import {
  capitalizeName,
  downloadFileFromUrl,
  formatDateRangeToIST,
  formatTimeForHDBCards,
} from "../../utils/commonFunctions";
import ProgramInfoCard from "../../components/CustomSubProgram";
import ProgramInfoTable from "../../components/SubProgramTable";
import { ProgramDetails } from "../Registration";
import { parseISO, format } from "date-fns";
import infinipathMeet from "../../assets/images/infinipathImg.webp";
import {
  BLESS_REJECTED,
  CANCELLED,
  COMPLETED,
  ON_HOLD,
  PAYMENT_REQUEST,
  PENDING,
  PENDING_APPROVAL,
  REJECTED,
  SAVE_DRAFT,
  STATUS,
  TRAVEL_PENDING,
  WAIT_LIST,
  WARNING,
  WARNING_MESSAGES,
} from "../../constants";
import caretDown from "../../assets/images/caret-down.svg";
import caretUp from "../../assets/images/caret-up.svg";
import ScrollingCountdown from "../../components/ScrollingCountdown";
import { getCall } from "../../services/apiService";
import CircularTimer from "../../components/CircularTimer";
import RandomLoopAudioPlayer from "../../common/components/RandomLoopAudioPlayer";
import { mahatreyaAudioMessages } from "../../constants/audoFiles";
import { endPoints } from "../../constants/urlConstants";
import nondoing from "../../assets/images/nondoing.svg";
import clsx from "clsx";
import mahatriara from "../../assets/images/mahatriara.svg";
import infiminute from "../../assets/images/Infiminute.svg";
import Footer from "../../common/components/Footer";
import pillerMobileImg from "../../assets/images/infiniminuteMobile.webp";
import { highlightMahatriaAndInfinitheism } from "../../common/components/HighlightMahatriaInfinitheism";
import Entrainment from "../../components/Entrainment";

import { useLocation } from "react-router-dom";

import { notify } from "../../common/components/ToastMessage";
import AlertPopup from "../../common/components/AlertPopup";
import { Snackbar } from "@mui/material";
import alertIcon from "../../assets/images/alert-icon.svg";
// import { ENT_TEXT_CONSTANTS } from "../../constants/entTextConstants";
import successTick from "../../assets/images/success-tick.svg";
import { useDispatch, useSelector } from "react-redux";
import { setfeatureFlags } from "../../reducers/registrationReducer";

const InfiniPrayer: React.FC = () => {
  const dispatch = useDispatch();
  const flags = useSelector(
    (state: unknown) => state.registrationDataSlice.featureFalgs || {},
  );
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [currentLyricIndex, setCurrentLyricIndex] = useState(-1);
  const [showCountdown, setShowCountdown] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [playMahatreyaAudioMessages, setPlayMahatreyaAudioMessages] =
    useState(false);
  const [showPlayAgainButton, setShowPlayAgainButton] = useState(false);
  const [lastStartedFromPlayAgain, setLastStartedFromPlayAgain] =
    useState(false);
  const audioRef = useRef(null);
  const navigate = useNavigate();
  const [currentNumber, setCurrentNumber] = useState(11);
  //add the logo url that is comming back end when it was added

  const [programs, setPrograms] = useState<ProgramDetails[] | null>(null);
  // const [flags, setFlags] = useState<{ [key: string]: boolean } | null>(null);
  const [loader, setLoader] = useState(false);
  const [showMoreId, setShowMoreId] = useState<string | number | null>(null);
  const [openProgramIds, setOpenProgramIds] = useState<(string | number)[]>([]);
  const [showContent, setShowContent] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [reloadPage, setReloadPage] = useState(false);
  const [alert, setAlert] = useState<{
    open: boolean;
    message: string[];
    type: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    confirmText?: string;
    cancelText?: string;
    onReupload?: () => void;
  }>({ open: false, message: [], type: "" });
  const location = useLocation();
  const seekerDetails = getItemInLocalStorage("seekerDetails") || {};
  const [showSnackbar, setShowSnackbar] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>("");
  const [snackBarIcon, setSnackBarIcon] = useState<string>("");
  const [registrationStatuses, setRegistrationStatuses] = useState<{
    [key: string]: boolean;
  }>({});
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const isProfileIncomplete =
    !seekerDetails?.firstName ||
    !seekerDetails?.lastName ||
    !seekerDetails?.address ||
    !seekerDetails?.dob;
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loadData = async () => {
    try {
      setLoader(true);
      const { programs, registrations, featureFlags } = await fetchProgramsData(
        seekerDetails?.id,
      );
      const programRegsitrationStatus = getStatusOfProgram(
        programs,
        registrations,
      );
      setPrograms(programRegsitrationStatus);
      // setFlags(featureFlags);
      dispatch(setfeatureFlags(featureFlags));
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setReloadPage(false);
      setLoader(false);
    }
  };
  useEffect(() => {
    if (!isPlaying || reloadPage) {
      loadData();
    } else {
      setShowSnackbar(true);
      setSnackbarMessage("Your sesssion has expired, please login again.");
      setSnackBarIcon("alert");
      setTimeout(() => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace("/");
      }, 1000);
    }
  }, [seekerDetails.id, reloadPage]);

  // Parse your LRC format lyrics
  const [lyrics] = useState([
    { time: 4.81, text: "Feeling Thy presence" },
    { time: 9.02, text: "Feeling Thy grace" },
    { time: 13.58, text: "Feeling Thy radiance" },
    { time: 18.14, text: "You are my source of faith and strength" },
    { time: 22.17, text: "You are my path and destination" },
    { time: 27.16, text: "And i am always connected to You" },
    { time: 35.31, text: "Nothing of me and everything of You" },
    { time: 44.03, text: "Lead me higher..." },
    { time: 48.58, text: "Lead me deeper..." },
    { time: 53.21, text: "Lead me beyond..." },
    { time: 57.1, text: "Lead me to You." },
  ]);
  useEffect(() => {
    if (currentTime >= 62 && isPlaying && audioRef.current) {
      audioRef?.current.pause();
      setShowTimer(true);
      setIsPlaying(false);
      setCurrentLyricIndex(-1);
    }
  }, [currentTime]);
  // Audio event listeners
  useEffect(() => {
    if (loader) return;
    const audio = audioRef.current;
    if (!audio) return;

    const updateTime = () => setCurrentTime(audio.currentTime);
    const handleEnded = () => {
      // Show timer when audio ends
      setShowTimer(true);
      setIsPlaying(false);
      setCurrentLyricIndex(-1);
    };

    audio.addEventListener("timeupdate", updateTime);
    audio.addEventListener("ended", handleEnded);

    return () => {
      audio.removeEventListener("timeupdate", updateTime);
      audio.removeEventListener("ended", handleEnded);
    };
  }, [loader]);

  // Update current lyric based on audio time
  const toastRef = useRef(false);

  useEffect(() => {
    console.log("Showing toast:", programs, location.state?.showToast, !loader);

    if (
      location.state?.showToast &&
      !loader &&
      !toastRef.current &&
      programs != null
    ) {
      console.log("Showing toast: inside", programs);

      notify(
        location.state.toasttitle,
        location.state.toastmessage,
        location.state.toastType || "success",
        location.state.iconGreen,
      );
      toastRef.current = true;

      // Optionally clear the state so the toast doesn't show again on refresh
      window.history.replaceState({}, document.title);
    }
  }, [programs]);
  useEffect(() => {
    if (!isPlaying) return;

    const currentIndex = lyrics.findIndex((lyric, index) => {
      const nextLyric = lyrics[index + 1];
      return (
        currentTime >= lyric.time &&
        (!nextLyric || currentTime < nextLyric.time)
      );
    });

    setCurrentLyricIndex(currentIndex);
  }, [currentTime, isPlaying, lyrics]);

  useEffect(() => {
    if (Array.isArray(programs) && programs.length > 0) {
      setOpenProgramIds(programs.map((p) => p.id));
    }
  }, [programs]);

  const checkRegistrationTime = (
    registrationStartsAt: string,
    programId: number,
  ) => {
    if (!registrationStartsAt) return;

    const now = new Date();
    const registrationStart = new Date(registrationStartsAt);

    if (now >= registrationStart) {
      setRegistrationStatuses((prev) => ({
        ...prev,
        [programId]: true,
      }));
    }
  };

  //This useEffect will be used to check the registration time for each program every second
  useEffect(() => {
    // Clear any existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    // Helper function to check if all registrations have started
    const areAllRegistrationsStarted = () => {
      if (!programs) return false;
      return programs.every((program) => {
        if (!program.registrationStartsAt) return true; // Skip programs without start time
        const now = new Date();
        const registrationStart = new Date(program.registrationStartsAt);
        return now >= registrationStart;
      });
    };

    // If all registrations have already started, no need to set up interval
    if (areAllRegistrationsStarted()) {
      return;
    }

    // Set up interval to check registration time
    intervalRef.current = setInterval(() => {
      programs?.forEach((program) => {
        if (program.registrationStartsAt) {
          checkRegistrationTime(program.registrationStartsAt, program.id);
        }
      });

      // Check if all registrations have started after updates
      if (areAllRegistrationsStarted()) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }
    }, 1000);

    // Initial check
    programs?.forEach((program) => {
      if (program.registrationStartsAt) {
        checkRegistrationTime(program.registrationStartsAt, program.id);
      }
    });

    // Cleanup on component unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [programs]);

  const handleStart = () => {
    setCurrentNumber(11); // Reset countdown number
    setShowPlayAgainButton(false);
    setPlayMahatreyaAudioMessages(false);
    setShowContent(true);
    if (isPlaying) {
      const audio = audioRef.current;
      if (audio) {
        audio.pause();
        setIsPlaying(false);
      }
    } else {
      setShowCountdown(true); // Start countdown instead of playing directly
    }
    // If play again button was visible, mark lastStartedFromPlayAgain as true
    setLastStartedFromPlayAgain(showPlayAgainButton);
  };

  const handleCountdownComplete = async () => {
    setShowCountdown(false);
    setIsPlaying(true);

    const audio = audioRef.current;
    if (!audio) return;

    try {
      await audio.play();
    } catch (error) {
      console.error("Error playing audio:", error);
    }
  };

  const handleTimerComplete = () => {
    setShowTimer(false);
    setCurrentTime(0);
    setPlayMahatreyaAudioMessages(true);
    const audio = audioRef.current;
    if (audio) {
      audio.currentTime = 0;
    }
  };

  const handleRegister = (eventId: string) => {
    navigate(`registration?programId=${eventId}`);
  };
  function formatCheckinTime(isoString: string) {
    if (!isoString) return "";
    const date = parseISO(isoString);
    return format(date, "hh:mm aaaa 'on' EEE, dd MMM yyyy")
      .replace("AM", "a.m.")
      .replace("PM", "p.m.");
  }

  const renderPillars = () => (
    <div className={styles.pillars_container}>
      <img src={pillars} alt="Three Pillars" className={styles.pillars_image} />
      <img
        src={pillerMobileImg}
        alt="Three Pillars Mobile"
        className={styles.pillars_image_mobile}
      />
    </div>
  );

  const renderLogos = () => {
    if (playMahatreyaAudioMessages || showPlayAgainButton) return null;
    return (
      <div className={styles.infiniminite_logo}>
        <img
          src={
            showCountdown || showTimer
              ? infiminute
              : isPlaying
                ? infiniprayerLogo
                : infiminute
          }
          alt="Infinipath Prayer"
          className={styles.infiniprayer}
        />
      </div>
    );
  };
  const highlightMahatria = (text: string) => {
    if (!text) return null;
    return text.split(/(mahatria)/gi).map((part, idx) =>
      part.toLowerCase() === "mahatria" ? (
        <span key={idx} className={styles.mahatria}>
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  const renderGreetings = () => {
    return (
      <div>
        {!showCountdown &&
        !showTimer &&
        !isPlaying &&
        !showPlayAgainButton &&
        !playMahatreyaAudioMessages ? (
          <div className={styles.greeting_section}>
            {seekerDetails?.fullName && (
              <div className={styles.nameDiv}>
                {seekerDetails?.legalFullName
                  ? capitalizeName(seekerDetails?.legalFullName)
                  : seekerDetails?.email}
                ,
              </div>
            )}
            <div className={styles.nameDiv}>
              experience the infinite through
            </div>
          </div>
        ) : playMahatreyaAudioMessages || showPlayAgainButton ? (
          <div className={styles.greeting_section}>
            {seekerDetails?.fullName && (
              <div className={styles.nameDiv}>
                Hi {capitalizeName(seekerDetails?.fullName)},
              </div>
            )}
            <div className={styles.redBorder}></div>
            <div className={styles.nameDiv}>Loving you so much</div>
            <img
              src={mahatriara}
              alt="Mahatria ra"
              className={styles.mahatriara}
            />
          </div>
        ) : null}
      </div>
    );
  };
  if (loader && !isPlaying) {
    return <Loader type="large" />;
  }

  const onInvoiceClick = (registrationId: number) => {
    console.log("Invoice clicked, onInvoiceClick", registrationId);
    getCall(endPoints.invoiceDownload(registrationId), undefined, false)
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          console.log("response format:", response.data.data);
          downloadFileFromUrl(
            response.data.data.invoicePdfUrl,
            response?.data?.data?.fileName,
          );
        } else {
          console.error("Failed to download invoice:", response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error downloading inv  oice:", error);
      });
    console.log("Invoice clicked, onInvoiceClick completed");
  };
  const onProformaClick = (registrationId: string) => {
    console.log("Invoice clicked , Proforma clicked");
    getCall(endPoints.proformaDownload(registrationId), undefined, false)
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          console.log("response to download invoice:", response?.data?.data);
          downloadFileFromUrl(response.data.data.data.proFormaInvoice);
        } else {
          console.error("Failed to download invoice:", response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error downloading invoice:", error);
      });
  };
  const handleCTAClick = async (
    programId: number,
    sectionId: number,
    selectedprogram: any,
  ) => {
    try {
      // Get the program's registration ID
      if (!selectedprogram?.registrationId) {
        console.error("No registration ID found");
        return;
      }
      // Get registration status
      const status = await getRegistrationStatus(
        selectedprogram.registrationId,
      );
      // Determine which section to navigate to based on status
      let targetSectionId = sectionId;
      if (
        status.approvalStatus === "pending" ||
        status.approvalStatus === REJECTED ||
        status.approvalStatus === ON_HOLD
      ) {
        targetSectionId = 1;
      } else if (
        status.approvalStatus === "approved" &&
        status.paymentStatus !== "online_completed" &&
        status.paymentStatus !== "offline_pending" &&
        status.paymentStatus !== "offline_completed"
      ) {
        targetSectionId = 2;
        console.log("targetSectionId", targetSectionId, sectionId);
        // If the user is not in section 3
        if (targetSectionId !== sectionId) {
          setAlert({
            open: true,
            message: WARNING_MESSAGES.ALREADY_BLESSED,
            type: WARNING,
            confirmText: "okay",
            onConfirm: () => {
              setAlert({ message: [], open: false, type: "" });
              loadData();
            },
          });
          setReloadPage(true);
          return;
        }
      } else if (
        status.approvalStatus === "approved" &&
        selectedprogram?.statusMessage?.state == PAYMENT_REQUEST
      ) {
        targetSectionId = 2;
      } else if (
        status.approvalStatus === "approved" &&
        (status.paymentStatus === "online_completed" ||
          status.paymentStatus === "offline_pending" ||
          status.paymentStatus === "offline_completed")
      ) {
        targetSectionId = 3;
      } else if (
        status.approvalStatus == REJECTED ||
        status.approvalStatus == ON_HOLD
      ) {
        setAlert({
          open: true,
          message: WARNING_MESSAGES.REJECTED,
          type: WARNING,
          confirmText: "okay",
          onConfirm: () => {
            setAlert({ message: [], open: false, type: "" });
            loadData();
          },
        });
        setReloadPage(true);
        return;
      }
      if (targetSectionId == 1) {
        navigate(`registration?programId=${programId}&isEdit=true`);
      } else if (
        targetSectionId === 2 &&
        selectedprogram?.statusMessage?.state == PAYMENT_REQUEST
      ) {
        navigate(`registration?programId=${programId}&editpayment=true`, {
          state: { sectionId: targetSectionId },
        });
      } else {
        navigate(`registration?programId=${programId}`, {
          state: { sectionId: targetSectionId },
        });
      }
    } catch (error) {
      console.error("Error in handleCTAClick:", error);
      // Fallback to original behavior if status check fails
      navigate(`registration?programId=${programId}`, {
        state: { sectionId },
      });
    }
  };

  const handleSummaryNavigation = (programId: number) => {
    navigate(`summary?programId=${programId}`);
  };

  const handleRandomLoopEnd = () => {
    console.log("Random loop ended, showing play again button");
    setShowPlayAgainButton(true);
    setPlayMahatreyaAudioMessages(false);
  };

  const handleCeaseUnfolding = () => {
    setShowCountdown(false);
    setShowTimer(false);
    setIsPlaying(false);
    setCurrentTime(0);
    setCurrentLyricIndex(-1);
    setPlayMahatreyaAudioMessages(false);
    setShowContent(true);

    const audio = audioRef.current;
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }
    // If last started from play again, show play again button only
    if (lastStartedFromPlayAgain) {
      setShowPlayAgainButton(true);
      setShowContent(false); // Hide infiniminute button
    } else {
      setShowPlayAgainButton(false);
      setShowContent(true); // Show infiniminute button
    }
  };

  const handleSnackbarClose = () => {
    setShowSnackbar(false);
  };
  const redirectTo = () => {
    if (isProfileIncomplete) {
      navigate("/myspace/profile", { state: { from: "infinipathPrayer" } });
      return;
    }
    navigate("/myspace/infinipath");
  };
  const infiniprayer = () => {
    return (
      <>
        {renderLogos()}
        <div className={styles.main_content}>
          <div>
            {showContent || showPlayAgainButton || playMahatreyaAudioMessages
              ? renderGreetings()
              : null}
            {playMahatreyaAudioMessages && (
              <RandomLoopAudioPlayer
                audioUrls={mahatreyaAudioMessages}
                onEnded={handleRandomLoopEnd}
              />
            )}
            <div>
              {/* Only show one of the buttons based on state */}
              {showContent &&
                !isPlaying &&
                !showCountdown &&
                !showTimer &&
                !playMahatreyaAudioMessages &&
                !showPlayAgainButton && (
                  <Button
                    onClick={handleStart}
                    buttonClassName={clsx(
                      styles.shortconfirmButton,
                      styles.startButton,
                    )}
                    buttonTextClassName={styles.confirmText}
                  >
                    infiniminute
                  </Button>
                )}
              {showPlayAgainButton &&
                !isPlaying &&
                !showCountdown &&
                !showTimer &&
                !playMahatreyaAudioMessages && (
                  <Button
                    onClick={handleStart}
                    buttonClassName={styles.playAgainButton}
                    buttonTextClassName={styles.playAgainText}
                  >
                    play again
                  </Button>
                )}
              {showCountdown && (
                <ScrollingCountdown
                  isVisible={showCountdown}
                  onComplete={handleCountdownComplete}
                  current={currentNumber}
                  setCurrent={setCurrentNumber}
                />
              )}

              {/* <div className={styles.prayer_wrapper}> */}
              <div
                className={`${styles.prayer_viewport} ${isPlaying && !showTimer ? styles.visible : styles.hidden}`}
              >
                <div
                  className={`${styles.prayer_content} ${isPlaying && !showTimer ? styles.visible : styles.hidden}`}
                  style={{
                    position: "relative",
                    height: "100%",
                    // Remove transform from container since we're using absolute positioning
                  }}
                >
                  {lyrics.map((lyric, lyricIndex) => {
                    // Only render lines that are close to current (for performance)
                    if (Math.abs(lyricIndex - currentLyricIndex) > 2) {
                      return null;
                    }

                    const isActive =
                      lyricIndex === currentLyricIndex ||
                      lyricIndex === currentLyricIndex + 1;
                    const isCurrent = lyricIndex === currentLyricIndex;
                    const isPrevious = lyricIndex === currentLyricIndex - 1;
                    const isNext = lyricIndex === currentLyricIndex + 1;

                    return (
                      <p
                        key={`${lyricIndex}-${lyric.time}`}
                        className={`${styles.prayer_line} ${
                          isActive
                            ? isCurrent
                              ? styles.current_line
                              : styles.next_line
                            : styles.inactive_line
                        }`}
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: `translate(-50%, -50%) translateY(${(lyricIndex - currentLyricIndex) * 47}px) scale(${isCurrent ? 1.05 : 1})`,
                          opacity: isCurrent
                            ? 1
                            : isPrevious || isNext
                              ? 0.6
                              : 0,
                          transition:
                            "opacity 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), color 0.4s ease-out, transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                          height: "35px",
                          lineHeight: "35px",
                          width: "100%",
                          textAlign: "center",
                          filter: `blur(${isCurrent ? "0px" : "0.5px"})`,
                          willChange: "opacity, transform, filter",
                        }}
                      >
                        {lyric.text}
                      </p>
                    );
                  })}
                </div>
              </div>

              {/* </div> */}

              <CircularTimer
                isVisible={showTimer}
                duration={60}
                onComplete={handleTimerComplete}
              />

              <audio ref={audioRef} preload="metadata">
                <source src={infiniprayeraudio} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </div>
          </div>
          <div className="unfolding_wrapper">
            {showCountdown || showTimer || isPlaying ? (
              <div
                className={styles.unfoldingText}
                onClick={handleCeaseUnfolding}
              >
                <span>←</span>
                <span>back to my space</span>
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className={styles.main_view}>
        {flags?.showInfiniminutePrayer ? (
          isProfileIncomplete ? (
            <>
              {renderPillars()}
              <div className={styles.content}>
                <div>
                  <div className={styles.newUserText}>
                    Wishing you Most and more...
                  </div>
                  <div className={styles.newUserWelcomeText}>
                    Welcome to infinitheism - a path that inspires
                    breakthroughs!
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {renderPillars()}
              {infiniprayer()}
            </>
          )
        ) : (
          <>
            {renderPillars()}
            <div className={styles.content}>
              <div>
                <div className={styles.newUserText}>
                  Wishing you Most and more...
                </div>
                <div className={styles.newUserWelcomeText}>
                  Welcome to infinitheism - a path that inspires breakthroughs!
                </div>
              </div>
            </div>
          </>
        )}

        {programs && programs.length ? (
          <div className={`${styles.programs_grid}`}>
            {programs.map((program) =>
              program.type?.key === "PT_ENTRAINMENT" ? (
                <Entrainment
                  seekerDetails={seekerDetails}
                  key={program?.id}
                  programDetails={program}
                  setLoader={setLoader}
                  setShowSnackbar={setShowSnackbar}
                  setSnackbarMessage={setSnackbarMessage}
                  setSnackBarIcon={setSnackBarIcon}
                />
              ) : (
                program.type?.key != "PT_INFINIPATH" && (
                  <div
                    key={program.id}
                    className={`${styles.program_container} ${
                      program?.statusMessage &&
                      program?.statusMessage?.state != SAVE_DRAFT &&
                      program?.statusMessage?.state != PENDING_APPROVAL &&
                      program?.statusMessage?.state != WAIT_LIST &&
                      program?.statusMessage?.state != REJECTED &&
                      program?.statusMessage?.state != CANCELLED &&
                      program?.statusMessage?.state != ON_HOLD &&
                      program?.statusMessage?.state != BLESS_REJECTED
                        ? styles.bg_image
                        : ""
                    }`}
                  >
                    {program?.statusMessage &&
                      program?.statusMessage?.state != SAVE_DRAFT &&
                      program?.statusMessage?.state != PENDING_APPROVAL &&
                      program?.statusMessage?.state != WAIT_LIST &&
                      program?.statusMessage?.state != REJECTED &&
                      program?.statusMessage?.state != CANCELLED &&
                      program?.statusMessage?.state != ON_HOLD &&
                      program?.statusMessage?.state != BLESS_REJECTED && (
                        <>
                          <div className={styles.program_status}>
                            <p>Congratulations!</p>
                            <p>
                              You have been blessed with{" "}
                              {highlightMahatriaAndInfinitheism(
                                program?.blessesProgram?.name,
                              )}
                            </p>
                          </div>
                          <div className={styles.seprationLine}></div>
                        </>
                      )}
                    <div key={program.id} className={styles.program_card}>
                      <div className={styles.program_header}>
                        <div className={styles.program_icon}>
                          <video
                            src={
                              program.bannerAnimationUrl ||
                              program.bannerImageUrl ||
                              hdbImg
                            }
                            className={styles.program_icon_image}
                            autoPlay
                            loop
                            muted
                            playsInline // Fallback image while video loads
                          />
                        </div>
                        <div className={styles.program_content}>
                          {(!program.statusMessage ||
                            program.statusMessage.state == SAVE_DRAFT) &&
                            (program.registrationWindowStatus ==
                              STATUS.OPENED ||
                              registrationStatuses[program.id]) && (
                              <div>
                                <p className={styles.program_subtitle}>
                                  {highlightMahatriaAndInfinitheism(
                                    program.name,
                                  )}
                                </p>
                                <div className={styles.program_description}>
                                  {highlightMahatria(
                                    program.description ||
                                      "A residential spiritual retreat with Mahatria.",
                                  )}
                                </div>
                                {/* <div className={styles.subProgramName}>
                                <span className={styles.subProgramList}>
                                  {program?.groupedPrograms?.map(
                                    (subProgram, index) => (
                                      <span key={index}>
                                        {" "}
                                        {highlightMahatriaAndInfinitheism(
                                          subProgram.name,
                                        )}
                                        {index <
                                        program.groupedPrograms.length - 1
                                          ? ","
                                          : ""}{" "}
                                      </span>
                                    ),
                                  )}
                                </span>
                              </div> */}
                              </div>
                            )}
                          {program.statusMessage &&
                            program.registrationWindowStatus == STATUS.OPENED &&
                            program.statusMessage.state != SAVE_DRAFT && (
                              <div>
                                <p className={styles.program_subtitle}>
                                  {highlightMahatriaAndInfinitheism(
                                    program.name,
                                  )}
                                </p>

                                {program?.statusMessage?.message?.map(
                                  (item) => (
                                    <div className={styles.program_description}>
                                      {highlightKeywords(
                                        item,
                                        () =>
                                          onInvoiceClick(
                                            program.registrationId,
                                          ),
                                        () =>
                                          onProformaClick(
                                            program.registrationId,
                                          ),
                                      )}
                                    </div>
                                  ),
                                )}
                              </div>
                            )}
                          {program.registrationWindowStatus ==
                            STATUS.NOT_OPENED &&
                            !registrationStatuses[program.id] && (
                              <div>
                                <p className={styles.program_subtitle}>
                                  {highlightMahatriaAndInfinitheism(
                                    program.name,
                                  )}
                                </p>
                                <div className={styles.program_description}>
                                  {highlightMahatria(
                                    program.description ||
                                      "A residential spiritual retreat with Mahatria.",
                                  )}
                                </div>
                                <div className={styles.program_description}>
                                 Registrations will open on {" "}
                                  {formatDateWithDay(
                                    program?.registrationStartsAt,
                                  )}{" "}
                                  at{" "}
                                  {formatTimeForHDBCards(
                                    program?.registrationStartsAt,
                                  )}
                                </div>
                              </div>
                            )}
                          {program.registrationWindowStatus ==
                            STATUS.CLOSED && (
                            <div>
                              <p className={styles.program_subtitle}>
                                {highlightMahatriaAndInfinitheism(program.name)}
                              </p>
                              <div className={styles.program_description}>
                                {highlightMahatria(
                                  program.description ||
                                    "A residential spiritual retreat with Mahatria.",
                                )}
                              </div>
                              <div className={styles.program_description}>
                                {highlightMahatria(
                                  "The registrations for this program are closed.",
                                )}
                              </div>
                              {program?.statusMessage &&
                                program?.statusMessage.message.map((item) => (
                                  <div className={styles.program_description}>
                                    {highlightKeywords(
                                      item,
                                      () =>
                                        onInvoiceClick(program.registrationId),
                                      () =>
                                        onProformaClick(program.registrationId),
                                    )}
                                  </div>
                                ))}
                            </div>
                          )}
                          <div className={styles.program_dates_section}>
                            <div className={styles.card_register_button}>
                              {program.registrationWindowStatus ==
                                STATUS.OPENED ||
                              registrationStatuses[program.id] ? (
                                !program.statusMessage ? (
                                  <Button
                                    onClick={() => handleRegister(program.id)}
                                    buttonClassName={styles.confirmButton}
                                    buttonTextClassName={styles.confirmText}
                                  >
                                    apply
                                  </Button>
                                ) : (
                                  <div className={styles.buttonContainer}>
                                    {program.statusMessage.state ==
                                      SAVE_DRAFT && (
                                      <Button
                                        onClick={() => {
                                          handleCTAClick(
                                            program?.id,
                                            1,
                                            program,
                                          );
                                        }}
                                        buttonClassName={styles.resumeButton}
                                        buttonTextClassName={
                                          styles.resumeButton
                                        }
                                      >
                                        resume registration
                                      </Button>
                                    )}
                                    {(program.statusMessage.state ==
                                      PENDING_APPROVAL ||
                                      program.statusMessage.state ===
                                        REJECTED ||
                                      program.statusMessage.state ===
                                        ON_HOLD) && (
                                      <Button
                                        onClick={() => {
                                          handleCTAClick(
                                            program?.id,
                                            1,
                                            program,
                                          );
                                        }}
                                        buttonClassName={styles.secondaryButton}
                                      >
                                        edit registration
                                      </Button>
                                    )}
                                    {program.statusMessage.state ==
                                      COMPLETED && (
                                      <Button
                                        onClick={() => {
                                          handleSummaryNavigation(program?.id);
                                        }}
                                        buttonClassName={styles.secondaryButton}
                                      >
                                        summary
                                      </Button>
                                    )}
                                    {program.statusMessage.state == PENDING && (
                                      <Button
                                        onClick={() => {
                                          handleCTAClick(
                                            program?.id,
                                            2,
                                            program,
                                          );
                                        }}
                                        buttonClassName={styles.confirmButton}
                                        buttonTextClassName={styles.confirmText}
                                      >
                                        make payment
                                      </Button>
                                    )}
                                    {program.statusMessage.state ==
                                      PAYMENT_REQUEST && (
                                      <Button
                                        onClick={() => {
                                          handleCTAClick(
                                            program?.id,
                                            2,
                                            program,
                                          );
                                        }}
                                        buttonClassName={styles.secondaryButton}
                                      >
                                        update payment
                                      </Button>
                                    )}
                                    {program.statusMessage.state ==
                                      TRAVEL_PENDING && (
                                      <div
                                        className={styles.travelButtonContainer}
                                      >
                                        <Button
                                          onClick={() => {
                                            handleCTAClick(
                                              program?.id,
                                              3,
                                              program,
                                            );
                                          }}
                                          buttonClassName={styles.confirmButton}
                                          buttonTextClassName={
                                            styles.confirmText
                                          }
                                        >
                                          {program?.travelInfo?.length > 0 &&
                                          program?.travelInfo[0]
                                            ?.travelInfoStatus ===
                                            SAVE_DRAFT ? (
                                            <span>resume travel</span>
                                          ) : (
                                            <span>update travel plan</span>
                                          )}
                                        </Button>
                                      </div>
                                    )}
                                  </div>
                                )
                              ) : (
                                <>
                                  {program.registrationWindowStatus ==
                                    STATUS.CLOSED && (
                                    <>
                                      {program.statusMessage &&
                                        program.statusMessage.state ==
                                          COMPLETED && (
                                          <Button
                                            onClick={() => {
                                              handleSummaryNavigation(
                                                program?.id,
                                              );
                                            }}
                                            buttonClassName={
                                              styles.secondaryButton
                                            }
                                          >
                                            summary
                                          </Button>
                                        )}
                                    </>
                                  )}
                                  {program.registrationWindowStatus ==
                                    STATUS.NOT_OPENED && <></>}
                                </>
                              )}
                            </div>
                            <div
                              className={styles.more_data}
                              onClick={() =>
                                setOpenProgramIds((prev) =>
                                  prev.includes(program.id)
                                    ? prev.filter((id) => id !== program.id)
                                    : [...prev, program.id],
                                )
                              }
                            >
                              <span> HDB/MSD Schedule </span>
                              <div className={styles.caretIcon}>
                                <img
                                  src={
                                    openProgramIds.includes(program.id)
                                      ? caretDown
                                      : caretUp
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {openProgramIds.includes(program.id) && (
                        <div className={styles.seprationLine}></div>
                      )}
                      <div>
                        {program.name != "Entrainment25" ? (
                          program.isGroupedProgram ? (
                            program.blessesProgram ? (
                              openProgramIds.includes(program.id) && (
                                <ProgramInfoTable
                                  subPrograms={program.groupedPrograms}
                                />
                              )
                            ) : (
                              openProgramIds.includes(program.id) && (
                                <ProgramInfoTable
                                  subPrograms={program.groupedPrograms}
                                />
                              )
                            )
                          ) : program?.noOfSession &&
                            program?.noOfSession > 0 ? (
                            program.blessesProgram ? (
                              openProgramIds.includes(program.id) && (
                                <ProgramInfoTable
                                  subPrograms={[program.blessesProgram]}
                                />
                              )
                            ) : (
                              openProgramIds.includes(program.id) && (
                                <ProgramInfoTable
                                  subPrograms={program.sessions}
                                />
                              )
                            )
                          ) : (
                            <ProgramInfoCard
                              title={program.name}
                              programDates={
                                program.startsAt && program.endsAt
                                  ? formatDateRangeToIST(
                                      program.startsAt,
                                      program.endsAt,
                                    )
                                  : ""
                              }
                              checkInTime={
                                program.checkinAt
                                  ? `${formatCheckinTime(program.checkinAt)}`
                                  : ""
                              }
                              checkOutTime={
                                program.checkoutAt
                                  ? `Latest by ${formatCheckinTime(program.checkoutAt)}`
                                  : ""
                              }
                              investment={
                                program.basePrice
                                  ? `INR ${(parseFloat(program.basePrice) + (parseFloat(program.basePrice) * parseFloat(program.igst || "0")) / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/-\n(plus GST 18%)`
                                  : ""
                              }
                            />
                          )
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                )
              ),
            )}
          </div>
        ) : null}

        {flags?.showInfinipath && (
          <div className={`${styles.programs_card}`}>
            <div className={styles.program_container}>
              <div className={styles.program_header}>
                <div className={styles.program_icon}>
                  <img
                    src={infinipathMeet}
                    alt={infinipathMeet.title}
                    className={styles.program_icon_image}
                  />
                </div>
                <div className={styles.program_content}>
                  <p className={styles.program_subtitle}>infinipath</p>
                  <div className={styles.program_description}>
                    Weekly live online growth sessions with{" "}
                    <span className={styles.mahatriaText}>Mahatria</span>,
                    offering consistent wisdom and practical insights for
                    holistic abundance and personal transformation.
                  </div>
                  <div className={styles.program_description}>
                    Register for live Zoom sessions Every SUNDAY (10 a.m. to
                    11:15 a.m. IST).
                  </div>
                  <Button
                    onClick={() => redirectTo()}
                    buttonClassName={styles.confirmButton}
                    buttonTextClassName={styles.confirmText}
                  >
                    register
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
      {alert.open && (
        <AlertPopup
          type={alert.type}
          message={alert.message}
          confirmText={alert?.confirmText ? alert.confirmText : ""}
          onConfirm={() => {
            if (alert?.onReupload) {
              alert.onReupload();
            } else if (alert?.onConfirm) {
              alert.onConfirm();
            }
            setAlert({ message: [], open: false, type: "" });
          }}
          cancelText={alert?.cancelText ? alert.cancelText : undefined}
          onCancel={() => {
            alert?.onCancel && alert.onCancel();
            setAlert({ message: [], open: false, type: "" });
          }}
        />
      )}
      <Snackbar
        open={showSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        className={styles.snackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        message={
          <span className={styles.snackbarMessage}>
            <img
              src={snackBarIcon === "success" ? successTick : alertIcon}
              alt="alert"
            />
            <span className={styles.snackbarError}>
              {/* {ENT_TEXT_CONSTANTS.DOWNLOAD_FAILED} */}
              {snackbarMessage}
            </span>
          </span>
        }
      />
    </>
  );
};

export default InfiniPrayer;

const highlightKeywords = (
  text: string,
  onInvoiceClick: () => void,
  onProformaClick: () => void,
) => {
  const regex = /(here|Tax invoice|Mahatria| Pro-forma Invoice|infinitheism)/gi;
  const parts = text.split(regex);

  // Check if both "here" and "invoice" appear in the message
  const hasHere = /here/i.test(text);
  const hasTaxInvoice = /Tax invoice/i.test(text);
  const hasProformaInvoice = /Pro-forma Invoice/i.test(text);
  return (
    <>
      {parts.map((part, idx) => {
        if (/^Mahatria$/i.test(part)) {
          return (
            <span key={idx} className={styles.mahatria}>
              {part}
            </span>
          );
        }
        if (/^infinitheism$/i.test(part)) {
          return (
            <span key={idx} style={styles.infinitheism}>
              {part}
            </span>
          );
        }
        if (/^here$/i.test(part)) {
          // If both "here" and "invoice" are present, only "here" is a link
          return (
            <span
              key={idx}
              className={styles.linkUnderlined}
              onClick={hasTaxInvoice ? onInvoiceClick : onProformaClick}
            >
              {part}
            </span>
          );
        }
        // if (/^invoice$/i.test(part)) {
        //   if (hasHere && hasTaxInvoice) {
        //     // If both are present, invoice is plain text
        //     return <span key={idx}>{part}</span>;
        //   } else {
        //     // If only invoice is present, make it a link
        //     return (
        //       <span key={idx} className={styles.link} onClick={onInvoiceClick}>
        //         {part}
        //       </span>
        //     );
        //   }
        // }
        return highlightMahatriaAndInfinitheism(part);
      })}
    </>
  );
};
